import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ai-message" }
const _hoisted_2 = { class: "inner-content" }
const _hoisted_3 = { class: "text-controls" }
const _hoisted_4 = {
  key: 0,
  class: "internal"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "suggestions delay-in-1000" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AnswerTabs = _resolveComponent("AnswerTabs")
  const _component_Cards = _resolveComponent("Cards")
  const _component_Answer = _resolveComponent("Answer")
  const _component_AiEditor = _resolveComponent("AiEditor")
  const _component_AiFile = _resolveComponent("AiFile")
  const _component_AiInput = _resolveComponent("AiInput")
  const _component_Divider = _resolveComponent("Divider")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Modify = _resolveComponent("Modify")
  const _component_SaveDoc = _resolveComponent("SaveDoc")
  const _component_Copy = _resolveComponent("Copy")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconLike = _resolveComponent("IconLike")
  const _component_Feedback = _resolveComponent("Feedback")
  const _component_IconDislike = _resolveComponent("IconDislike")
  const _component_AiSugggestion = _resolveComponent("AiSugggestion")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AnswerTabs, {
        ref: "answer-tabs",
        item: $props.item,
        "chat-id": $props.chatId,
        loading: $options.self_loading,
        sources: $options.sources,
        "last-answer": $props.lastAnswer
      }, null, 8 /* PROPS */, ["item", "chat-id", "loading", "sources", "last-answer"]),
      ($options.cards?.length)
        ? (_openBlock(), _createBlock(_component_Cards, {
            key: 0,
            class: "cards",
            cards: $options.cards,
            loading: $options.self_loading,
            sources: $options.sources,
            readonly: $props.readonly
          }, null, 8 /* PROPS */, ["cards", "loading", "sources", "readonly"]))
        : _createCommentVNode("v-if", true),
      ($props.item.data?.text)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($options.self_loading)
              ? (_openBlock(), _createBlock(_component_Answer, {
                  key: 0,
                  ref: "answer",
                  class: "answer",
                  restricted: $props.restricted,
                  text: $props.item.data.text,
                  generating: $props.generating,
                  intermediate: $options.intermediate,
                  onTextAdded: $options.onTextAdded
                }, null, 8 /* PROPS */, ["restricted", "text", "generating", "intermediate", "onTextAdded"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($options.is_editor)
                    ? (_openBlock(), _createBlock(_component_AiEditor, {
                        key: 0,
                        class: "editor",
                        "post-text": $props.item.data.text,
                        loading: $props.generating,
                        onSave: _cache[0] || (_cache[0] = $event => (_ctx.$emit('save', $event))),
                        onRefrag: _cache[1] || (_cache[1] = $event => (_ctx.$emit('refrag', $event)))
                      }, null, 8 /* PROPS */, ["post-text", "loading"]))
                    : (_openBlock(), _createBlock(_component_Answer, {
                        key: 1,
                        ref: "answer",
                        class: "answer",
                        restricted: $props.restricted,
                        generating: $props.generating,
                        text: $props.item.data.text
                      }, null, 8 /* PROPS */, ["restricted", "generating", "text"]))
                ], 64 /* STABLE_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.file_download, (id) => {
        return (_openBlock(), _createBlock(_component_AiFile, {
          id: id,
          key: id,
          restricted: $props.restricted,
          class: "file-cards"
        }, null, 8 /* PROPS */, ["id", "restricted"]))
      }), 128 /* KEYED_FRAGMENT */)),
      ($options.input)
        ? (_openBlock(), _createBlock(_component_AiInput, {
            key: 2,
            class: "ai-buttons",
            disabled: !$props.lastAnswer,
            input: $options.input,
            onPrompt: _cache[2] || (_cache[2] = $event => (_ctx.$emit('ask-ai', $event)))
          }, null, 8 /* PROPS */, ["disabled", "input"]))
        : _createCommentVNode("v-if", true)
    ]),
    (!$options.self_loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_Divider, { m: "1.6rem 0" }),
          _createElementVNode("div", _hoisted_3, [
            ($options.internal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_Icon, {
                    class: "alert-icon",
                    icon: "alert-circle",
                    stroke: "var(--error-700)",
                    width: "2rem",
                    height: "2rem"
                  }),
                  _cache[10] || (_cache[10] = _createTextVNode(" This AI response might contain internal company information. Do not share externally. "))
                ]))
              : _createCommentVNode("v-if", true),
            (!$props.readonly && $props.lastAnswer)
              ? (_openBlock(), _createBlock(_component_Modify, {
                  key: 1,
                  disabled: $props.generating,
                  onAskAi: _cache[3] || (_cache[3] = $event => (_ctx.$emit('ask-ai', $event)))
                }, null, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true),
            (!$props.readonly && !$props.item.data?.file_download && !$options.is_editor)
              ? (_openBlock(), _createBlock(_component_SaveDoc, {
                  key: 2,
                  disabled: $props.generating,
                  class: "save-doc",
                  size: "1.6rem",
                  color: "var(--gray-700)",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                  onSave: _cache[5] || (_cache[5] = $event => (_ctx.$dispatch('document-save', {ext: $event})))
                }, null, 8 /* PROPS */, ["disabled"]))
              : _createCommentVNode("v-if", true),
            ($props.item.data?.text && !$options.is_editor)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 3,
                  text: "Copy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Copy, {
                      onCopy: _cache[6] || (_cache[6] = $event => ($options.copyAnswer()))
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 4,
                  text: "Good answer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Feedback, {
                      "show-popover": !$options.liked,
                      onSend: _cache[7] || (_cache[7] = $event => (_ctx.$emit('like', $event)))
                    }, {
                      default: _withCtx(({visible}) => [
                        _createVNode(_component_IconLike, {
                          class: "pointer",
                          hoverable: "",
                          hover: visible,
                          "stroke-width": "1",
                          width: "1.6rem",
                          height: "1.6rem",
                          liked: $options.liked,
                          stroke: "var(--gray-700)",
                          icon: "thumbs-up"
                        }, null, 8 /* PROPS */, ["hover", "liked"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show-popover"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (!$props.readonly)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 5,
                  text: "Bad answer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Feedback, {
                      "show-popover": !$options.disliked,
                      onSend: _cache[8] || (_cache[8] = $event => (_ctx.$emit('dislike', $event)))
                    }, {
                      default: _withCtx(({visible}) => [
                        _createVNode(_component_IconDislike, {
                          class: "pointer",
                          hoverable: "",
                          hover: visible,
                          "stroke-width": "1",
                          width: "1.6rem",
                          height: "1.6rem",
                          disliked: $options.disliked,
                          stroke: "var(--gray-700)",
                          icon: "thumbs-down"
                        }, null, 8 /* PROPS */, ["hover", "disliked"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["show-popover"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          (!$props.readonly && $options.suggestions)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                disabled: $props.generating
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "segment-title more" }, [
                  _createElementVNode("span", null, "More suggestions")
                ], -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.suggestions, (suggestion, i) => {
                    return (_openBlock(), _createBlock(_component_AiSugggestion, {
                      key: i,
                      suggestion: suggestion,
                      onAskAi: _cache[9] || (_cache[9] = $event => (_ctx.$emit('ask-ai', $event)))
                    }, null, 8 /* PROPS */, ["suggestion"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ], 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}